import { useState, useEffect } from 'react';
import Card from '@mui/material/Card';
import DashboardLayout from 'prefabsComponents/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'prefabsComponents/Navbars/DashboardNavbar';
import Footer from 'prefabsComponents/Footer';
import DataTable from 'prefabsComponents/Tables/DataTable';
import useFetch from 'hooks/useFetch';
import DefaultCell from 'layouts/pages/orders/order-list/components/DefaultCell';
import DataTableLoader from 'components/DataTableLoader';
import DataTableHeaderOptions from 'components/DataTableHeaderOptions';
import DataTableDocumentActions from 'components/DataTableDocumentActions';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CreateNewModal from './CreateNewModal';
import Swal from 'sweetalert2';
import axios from 'axios';

const Clients = () => {
    const { data, isLoading, refetch } = useFetch('/api/maintenance/clients/');
    const [dataTableData, setDataTableData] = useState({ columns: [], rows: [] });
    const [selectedClient, setSelectedClient] = useState(null);

    useEffect(() => {
        if(data){
            const renderCell = ({ value }) => <DefaultCell value={value} />;

            const columns = [
                { Header: 'Id', accessor: 'id', Cell: renderCell },
                { Header: 'Nombre', accessor: 'nombre', Cell: renderCell },
                { Header: 'Comuna', accessor: 'comuna', Cell: renderCell },
                { Header: 'Dirección', accessor: 'direccion', Cell: renderCell },
                { Header: 'Razón Social', accessor: 'razon_social', Cell: renderCell },
                { Header: 'Rut', accessor: 'rut', Cell: renderCell },
                { Header: 'Teléfono', accessor: 'telefono', Cell: renderCell },
                { Header: 'Acciones', accessor: 'acciones', Cell: renderCell },
            ];

            const rows = data.map((client) => ({
                id: client.id,
                nombre: client.nombre,
                razon_social: client.razon_social || 'N/A',
                rut: client.rut,
                direccion: client.direccion,
                comuna: client.comuna,
                telefono: client.telefono || 'N/A',
                acciones: (
                    <DataTableDocumentActions
                        actions={[{
                            Icon: EditIcon,
                            onClick: () => handleEdit(client),
                            color: 'primary'
                        }]}
                    />
                )
            }));

            setDataTableData({ columns, rows });
        }
    }, [data]);

    const handleEdit = (client) => {
        setSelectedClient(client);
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <DataTableHeaderOptions
                createNewTitle='Nuevo Cliente'
                dataTableData={dataTableData}
                getData={refetch}
                isLoading={isLoading}
                hasFilters={false}
                CreateNewModal={CreateNewModal}
                selectedDocument={selectedClient}
                setSelectedDocument={setSelectedClient}
            />
            <Card>
                {isLoading ? (
                    <DataTableLoader />
                ) : (
                    <DataTable
                        table={dataTableData}
                        entriesPerPage={true}
                        canSearch={true}
                        showTotalEntries={true}
                    />  
                )}
            </Card>
            <Footer />
        </DashboardLayout>
    );
}

export default Clients;